import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white" style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
            <h1 className="h4 text-uppercase mb-1">passenger Data</h1>
            <p className="mb-0">Passenger details</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/passenger-level-data/view-header.js